(() => {
  if (window.__snugInlineBundleLoaded) return;
  window.__snugInlineBundleLoaded = true;
  const routeRoot = () => window.Shopify?.routes?.root || '/';
  const cartElement = () => document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const renderCart = (state, cart) => {
    if (!state?.sections || !cart?.getSectionsToRender) return;
    cart.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const text = state.sections[section.id];
      if (!target || !text) return;
      const fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('#minicart-form');
      if (fresh) target.innerHTML = fresh.innerHTML;
    });
    cart.cartAction?.();
  };
  function initialise(root) {
    if (root.dataset.snugInitialised === 'true') return;
    const data = root.querySelector('[data-bundle-product]');
    if (!data) return;
    let config;
    try { config = JSON.parse(data.textContent); } catch { return; }
    const labels = config.labels;
    const t = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll(`{${name}}`, value), labels[key] || key);
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: root.dataset.currency || 'AUD' });
    const format = (cents) => money.format(cents / 100);
    const query = (selector) => root.querySelector(selector);
    const buttons = [...root.querySelectorAll('[data-bundle-pack]')];
    const items = query('[data-bundle-items]');
    const add = query('[data-bundle-add]');
    const addLabel = query('[data-bundle-add-label]');
    const total = query('[data-bundle-total]');
    const before = query('[data-bundle-before]');
    const error = query('[data-bundle-error]');
    const quantity = query('[data-bundle-quantity]');
    const quantityButtons = [...root.querySelectorAll('[data-snug-quantity-choice]')];
    if (!items || !add || !total || !quantity || !config.variants.length) return;
    const initial = config.variants.find((variant) => variant.available && variant.id === config.product.selectedVariantId)
      || config.variants.find((variant) => variant.available);
    if (!initial) return;
    let mode = '1';
    let pack = 1;
    let busy = false;
    let choices = [initial.options.slice()];
    let cartState = window.SnugBundleCart?.current || null;
    const variantFor = (values) => config.variants.find((variant) => variant.options.every((value, index) => value === values[index]));
    const selected = () => choices.slice(0, pack).map(variantFor);
    const rateFor = (count) => window.SnugBundleCart?.rate(count) ?? (count >= 4 ? 10 : count >= 2 ? 5 : 0);
    const percent = (count = pack) => rateFor((cartState?.eligibleCount || 0) + count);
    // Shopify truncates the per-item percentage discount to whole minor units.
    const estimated = (variants, rate) => variants.reduce((sum, variant) => sum + (variant ? variant.price - Math.floor(variant.price * rate / 100) : 0), 0);
    const stockValid = (variants) => {
      const counts = new Map();
      for (const variant of variants) {
        if (!variant?.available) return false;
        counts.set(variant.id, (counts.get(variant.id) || 0) + 1);
      }
      return [...counts].every(([id, count]) => {
        const variant = config.variants.find((candidate) => candidate.id === id);
        const inCart = (cartState?.cart.items || []).filter((item) => String(item.variant_id) === id).reduce((sum, item) => sum + item.quantity, 0);
        return variant.inventoryLimit === null || variant.inventoryLimit === undefined || count + inCart <= variant.inventoryLimit;
      });
    };
    const showError = (message) => { error.textContent = message; error.hidden = false; };
    const updateTotals = () => {
      const variants = selected();
      const rate = percent();
      const subtotal = variants.reduce((sum, variant) => sum + (variant?.price || 0), 0);
      const valid = variants.length === pack && stockValid(variants);
      total.textContent = format(estimated(variants, rate));
      before.textContent = format(subtotal);
      before.hidden = !rate;
      add.disabled = busy || !valid;
      if (!busy) addLabel.textContent = valid ? t(pack === 1 ? 'add' : 'add_items', { count: pack }) : t('unavailable');
      query('[data-bundle-selection-summary]').textContent = t(pack === 1 ? 'one_selected' : 'selection', { count: pack });
      query('[data-bundle-saving]').textContent = rate ? t('save_percent', { percent: rate }) : t('one_item');
      buttons.forEach((button) => {
        const count = button.dataset.bundlePack === 'plus' ? Number(quantity.value) : Number(button.dataset.bundlePack);
        const reference = variants.find(Boolean) || initial;
        const values = button.dataset.bundlePack === mode ? variants : Array(count).fill(reference);
        button.querySelector('[data-pack-price]').textContent = format(estimated(values, percent(count)));
      });
      if (!valid && variants.every((variant) => variant?.available)) showError(t('stock_error'));
    };
    const renderItems = (restore = null) => {
      while (choices.length < pack) choices.push((choices[0] || initial.options).slice());
      items.replaceChildren();
      choices.slice(0, pack).forEach((values, itemIndex) => {
        const item = document.createElement('div');
        item.className = `snug-inline-bundle__item${pack === 1 ? ' is-single' : ''}`;
        const heading = document.createElement('strong');
        heading.className = 'snug-inline-bundle__item-number';
        heading.textContent = `${t('item')} ${itemIndex + 1}`;
        item.appendChild(heading);
        const controls = document.createElement('div');
        controls.className = 'snug-inline-bundle__item-controls';
        config.options.forEach((option, optionIndex) => {
          if (option.name === 'Title' && option.values.length === 1 && option.values[0] === 'Default Title') return;
          const wrap = document.createElement('label');
          wrap.className = 'snug-inline-bundle__select-wrap';
          const label = document.createElement('span');
          label.textContent = option.name;
          const select = document.createElement('select');
          select.disabled = busy;
          select.dataset.itemIndex = itemIndex;
          select.dataset.optionIndex = optionIndex;
          select.setAttribute('aria-label', `${label.textContent} — ${t('item')} ${itemIndex + 1}`);
          option.values.forEach((value) => {
            const available = config.variants.some((variant) => variant.available && variant.options[optionIndex] === value
              && variant.options.every((entry, index) => index >= optionIndex || entry === values[index]));
            const choice = document.createElement('option');
            choice.value = value;
            choice.textContent = available ? value : `${value} — ${t('sold_out')}`;
            choice.disabled = !available;
            choice.selected = value === values[optionIndex];
            select.appendChild(choice);
          });
          select.addEventListener('change', () => {
            if (busy) return;
            error.hidden = true;
            const next = choices[itemIndex].slice();
            next[optionIndex] = select.value;
            const exact = variantFor(next);
            if (!exact?.available) {
              const fallback = config.variants.find((variant) => variant.available && variant.options.every((value, index) => index > optionIndex || value === next[index]));
              if (fallback) { choices[itemIndex] = fallback.options.slice(); showError(t('quantity_adjusted')); }
              else choices[itemIndex] = next;
            } else choices[itemIndex] = next;
            renderItems({ itemIndex, optionIndex });
          });
          wrap.append(label, select);
          controls.appendChild(wrap);
        });
        const price = document.createElement('span');
        price.className = 'snug-inline-bundle__item-price';
        const variant = variantFor(values);
        price.textContent = variant?.available ? format(estimated([variant], percent())) : t('sold_out');
        item.append(controls, price);
        items.appendChild(item);
      });
      query('[data-bundle-config-title]').textContent = t(pack === 1 ? 'choose_options' : 'choose_each', { count: pack });
      updateTotals();
      if (restore) requestAnimationFrame(() => {
        const select = items.querySelector(`select[data-item-index="${restore.itemIndex}"][data-option-index="${restore.optionIndex}"]`);
        const visual = select?.closest('.snug-inline-bundle__select-wrap')?.querySelector('[data-snug-colour-trigger]');
        (visual || select)?.focus();
      });
    };
    const choosePack = (button) => {
      if (busy) return;
      mode = button.dataset.bundlePack;
      pack = mode === 'plus' ? Math.max(5, Math.min(8, Math.trunc(Number(quantity.value)) || 5)) : Number(mode);
      quantity.value = String(mode === 'plus' ? pack : Number(quantity.value) || 5);
      quantityButtons.forEach((candidate) => {
        const chosen = candidate.dataset.snugQuantityChoice === quantity.value;
        candidate.classList.toggle('is-selected', chosen);
        candidate.setAttribute('aria-pressed', String(chosen));
      });
      query('[data-bundle-quantity-wrap]').hidden = mode !== 'plus';
      buttons.forEach((candidate) => {
        const chosen = candidate === button;
        candidate.classList.toggle('is-selected', chosen);
        candidate.setAttribute('aria-checked', String(chosen));
        candidate.tabIndex = chosen ? 0 : -1;
      });
      error.hidden = true;
      renderItems();
    };
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => choosePack(button));
      button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1
          : (index + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + buttons.length) % buttons.length;
        buttons[next].focus(); choosePack(buttons[next]);
      });
    });
    quantity.addEventListener('change', () => choosePack(buttons.find((button) => button.dataset.bundlePack === 'plus')));
    quantityButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (busy) return;
        quantity.value = button.dataset.snugQuantityChoice;
        choosePack(buttons.find((candidate) => candidate.dataset.bundlePack === 'plus'));
      });
    });
    window.addEventListener('snug:bundle-cart', (event) => {
      if (!root.isConnected) return;
      cartState = event.detail;
      renderItems();
    });
    add.addEventListener('click', async () => {
      if (busy || !stockValid(selected())) return;
      busy = true;
      add.disabled = true;
      add.setAttribute('aria-busy', 'true');
      root.querySelectorAll('select, [data-bundle-pack], [data-snug-quantity-choice]').forEach((control) => { control.disabled = true; });
      addLabel.textContent = t('adding');
      error.hidden = true;
      try {
        const currentState = window.SnugBundleCart?.current;
        const [currentCart, snapshotResponse] = await Promise.all([
          currentState ? Promise.resolve(currentState) : window.SnugBundleCart?.refresh(),
          fetch(`${routeRoot()}products/${encodeURIComponent(config.product.handle)}.js`, { cache: 'no-store', credentials: 'same-origin' })
        ]);
        cartState = currentCart || null;
        if (!snapshotResponse.ok) throw new Error(t('add_error'));
        const snapshot = await snapshotResponse.json();
        const fresh = new Map(snapshot.variants.map((variant) => [String(variant.id), variant]));
        config.variants.forEach((variant) => {
          const current = fresh.get(variant.id);
          variant.available = current?.available === true;
          if (current) variant.price = current.price;
        });
        const variants = selected();
        if (!stockValid(variants)) throw new Error(t('stock_error'));
        const group = `snug-${config.product.id}-${crypto.randomUUID()}`;
        const payload = { items: variants.map((variant, index) => ({ id: variant.id, quantity: 1,
          properties: { '_Snug bundle': group, '_Bundle item': `${index + 1} of ${pack}` }
        })) };
        const cart = cartElement();
        const sections = cart?.getSectionsToRender?.() || [];
        if (sections.length) {
          payload.sections = sections.map((section) => section.id);
          payload.sections_url = location.pathname;
        }
        const response = await fetch(root.dataset.cartAddUrl, { method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || t('add_error'));
        renderCart(result, cart);
        cart?.setActiveElement?.(add);
        cart?.open?.({ source: add });
        const state = await window.SnugBundleCart?.refresh();
        if (state) {
          document.querySelectorAll('.cart-count').forEach((badge) => {
            const text = [...badge.childNodes].find((node) => node.nodeType === Node.TEXT_NODE);
            if (text) text.nodeValue = String(state.cart.item_count);
            else badge.prepend(document.createTextNode(String(state.cart.item_count)));
          });
          document.querySelector('header-total-price')?.updateTotal?.(state.cart);
          document.querySelector('free-ship-progress-bar')?.init?.(state.cart.items_subtotal_price);
        }
        window.dispatchEvent(new CustomEvent('snug:cart-added', { detail: { count: state?.cart.item_count, quantity: pack, productTitle: config.product.title, source: add } }));
      } catch (cause) { showError(cause.message || t('add_error')); }
      finally {
        busy = false;
        add.removeAttribute('aria-busy');
        root.querySelectorAll('select, [data-bundle-pack], [data-snug-quantity-choice]').forEach((control) => { control.disabled = false; });
        renderItems();
      }
    });
    const main = document.querySelector('[id^="MainProduct-"] .product-detail__information .product-detail__buy-buttons.button-trigger__sticky');
    if (main) main.before(root);
    root.dataset.snugInitialised = 'true';
    root.classList.add('is-ready');
    document.body.classList.add('snug-unified-purchase-active');
    renderItems();
  }
  const initialiseAll = () => document.querySelectorAll('[data-snug-inline-bundle]').forEach(initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  else initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
})();

